/*eslint-disable */
import root from '../_helpers/consultRoots';
let consultPatientApiUrl = root.consultPatientApiUrl.link;
let consultPatientDetailByIdApiUrl = root.consultPatientDetailByIdApiUrl.link;
let consultPatientNotesApiUrl = root.consultPatientNotesApiUrl.link;
let updateConsultAppointmentDetailApiUrl = root.updateConsultAppointmentDetailApiUrl.link;
let patientWithChatRoomCreatedApiUrl = root.patientWithChatRoomCreatedApiUrl.link;
let patientWithChatRoomDetailApiUrl = root.patientWithChatRoomDetailApiUrl.link;
let remarksForPatientApiUrl = root.remoarkForPatientApiUrl.link;
let prescriptionForPatientApiUrl = root.prescriptionForPatientApiUrl.link;
let patientMessageListApiUrl = root.patientMessageListApiUrl.link;
let replyOnPatientMsgApiUrl = root.replyOnPatientMsgApiUrl.link;
let doctorAvaibleDayTimeForConsultApiUrl = root.doctorAvaibleDayTimeForConsultApiUrl.link;
let patientPrescriptionReCreatedApiUrl = root.patientPrescriptionReCreatedApiUrl.link;
import axios from 'axios';
import Vue from 'vue'
export default {
  state: {
    getconsultPatientState:{},
    getconsultPatientByIdState:{},
    getNotesOfPatientState:{},
    getRemarksOfPatientState:{},
    getPrescriptionOfPatientState:{}
  },
  mutations: {
    getconsultPatientMutation(state, value) {
      Vue.set(state, 'getconsultPatientState', value);
    },
    getconsultPatientByIdMutation(state, value) {
      Vue.set(state, 'getconsultPatientByIdState', value);
    },
    getNotesOfPatientMutation(state, value) {
      Vue.set(state, 'getNotesOfPatientState', value);
    },
    getRemarksOfPatientMutation(state, value) {
      Vue.set(state, 'getRemarksOfPatientState', value);
    },
    getPrescriptionOfPatientMutation(state, value) {
      Vue.set(state, 'getPrescriptionOfPatientState', value);
    }
  },
  actions: {  
    reCreatePrescriptionOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(patientPrescriptionReCreatedApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    doctorAvaibleDayTimeForConsultMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(doctorAvaibleDayTimeForConsultApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    replyOnPatientMsgMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(replyOnPatientMsgApiUrl + payload.data.id + '/', payload.data.data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getpatientMessageListMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(patientMessageListApiUrl)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getconsultPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(consultPatientApiUrl)
          .then((response) => {
            context.commit('getconsultPatientMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getconsultPatientDetailyIdMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(consultPatientDetailByIdApiUrl + payload.id + '/')
          .then((response) => {
            context.commit('getconsultPatientByIdMutation', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getNotesListOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(consultPatientNotesApiUrl + "?patient_id=" + payload.id)
          .then((response) => {
            context.commit('getNotesOfPatientMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createNotesOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(consultPatientNotesApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    removeNotesOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(consultPatientNotesApiUrl + payload.id + '/')
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateNotesDataOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(consultPatientNotesApiUrl + payload.data.id + '/', payload.data.data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateAppointmentDetailsMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(updateConsultAppointmentDetailApiUrl + payload.data.id + '/', payload.data.data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createChatRoomForPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(patientWithChatRoomCreatedApiUrl + payload.data.id + '/', payload.data.data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getChatRoomDetailForPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(patientWithChatRoomDetailApiUrl + payload.id + '/')
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getChatRoomDetailForPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(patientWithChatRoomDetailApiUrl + payload.id + '/')
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getRemarksListOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(remarksForPatientApiUrl + "?patient_id=" + payload.id)
          .then((response) => {
            context.commit('getRemarksOfPatientMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createRemarksOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(remarksForPatientApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    removeRemarksOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(remarksForPatientApiUrl + payload.id + '/')
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateRemarksDataOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(remarksForPatientApiUrl + payload.data.id + '/', payload.data.data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getPrescriptionListOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(prescriptionForPatientApiUrl + "?appointment_id=" + payload.id)
          .then((response) => {
            context.commit('getPrescriptionOfPatientMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createPrescriptionOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(prescriptionForPatientApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    removePrescriptionOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(prescriptionForPatientApiUrl + payload.id + '/')
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updatePrescriptionDataOfPatientMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(prescriptionForPatientApiUrl + payload.data.id + '/', payload.data.data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    }
  },
  getters: {
    getconsultPatientGetters: state => state.getconsultPatientState,
    getconsultPatientByIdGetters: state => state.getconsultPatientByIdState,
    getNotesOfPatientGetters : state => state.getNotesOfPatientState,
    getRemarksOfPatientGetters : state => state.getRemarksOfPatientState,
    getPrescriptionOfPatientGetters : state => state.getPrescriptionOfPatientState
  }
}